import { render, staticRenderFns } from "./LawyerModal.vue?vue&type=template&id=9b99a872&"
import script from "./LawyerModal.vue?vue&type=script&lang=js&"
export * from "./LawyerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports